import React from 'react'
import { Label } from 'reactstrap'

const ImportUserSummary = () => {
    return (
        <React.Fragment>
            <div>
                <Label className='mb-0'>No of users Imported: 3</Label><br />
                <Label className='mb-0'>No of users not Rejected:  0</Label> <br />
                <Label className='mb-0'>No of users alredy exist, skipped:  0 </Label>
            </div>
        </React.Fragment>
    )
}

export default ImportUserSummary